import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
export const CrossedRangeValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
   const minNumber = control.get("desdeFolio");
   const maxNumber = control.get("hastaFolio");
   return minNumber && maxNumber && (minNumber.value > maxNumber.value || maxNumber.value < minNumber.value) ? { numberOutOfRange: true } : null;
};
